import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {retryAfterMillis} from '../shared/constants';
import {AlarmAttributeType} from '../model/alarm-attribute-type.model';
import {isString, utf8Decode} from 'sdv-common';

@Injectable({providedIn: 'root'})
export class AlarmAttributeTypeService {

  private alarmAttributeTypes: AlarmAttributeType[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('alarm-attribute-types', {
      $limit: 1000,
      $offset: 0
    }).subscribe(response => {
      const alarmAttributeTypes: AlarmAttributeType[] = [];
      for (const alarmAttributeType of response) {
        alarmAttributeTypes.push(this.covertAlarmAttributeType(alarmAttributeType));
      }
      this.alarmAttributeTypes = alarmAttributeTypes;
    }, err => {
      this.apiService.error({}, err);
      setTimeout(() => this.load(), retryAfterMillis);
    });
  }

  private covertAlarmAttributeType(alarmAttributeType) {
    return {
      id: alarmAttributeType.id || 0,
      system: alarmAttributeType.system || false,
      quantity: alarmAttributeType.quantity || 1,
      thymeleaf: utf8Decode(alarmAttributeType.thymeleaf || '')
    };
  }

  getTypes() {
    return this.alarmAttributeTypes;
  }

  get(id) {
    if (isString(id)) {
      id = parseInt(id);
    }
    for (const alarmAttributeType of this.getTypes()) {
      if (alarmAttributeType.id === id) {
        return alarmAttributeType;
      }
    }
    return {
      id,
      quantity: 0,
      thymeleaf: id
    };
  }
}
